import * as React from "react";
import {
  Text,
  TextInput,
  View,
  StyleSheet,
  Image,
  TouchableWithoutFeedback,
  TouchableOpacity,
  Dimensions
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import { modifyPartner } from "../../redux/actions/PartnerActions";
import GlobalStyles from "../../components/GlobalStyles";
import { useSelector } from "react-redux";
import { user_unset_firstrun } from "../../redux/actions/UserActions";

export default function FirstSigninDetailScreen({ route }) {
  const navigation = useNavigation();

  const win = Dimensions.get("window");

  var setEmail = useSelector((state) => state.user.user.attributes.email);
  var setFname = useSelector((state) => state.user.user.attributes.family_name);
  var setGname = useSelector((state) => state.user.user.attributes.given_name);
  var setPhone = useSelector(
    (state) => state.user.user.attributes.phone_number
  );
  var setReferral = useSelector(
    (state) => state.user.user.attributes['custom:refererId']
  );

  const [email, onChangeEmailText] = React.useState("");
  const [phone, onChangePhoneText] = React.useState("");
  const [givenName, onChangeGivenNameText] = React.useState("");
  const [familyName, onChangeFamilyNameText] = React.useState("");
  const [reffererId, onChangeReffererIdText] = React.useState("");

  const [emailMessageFlag, setEmailMessageFlag] = React.useState(false);
  const [emailMessageFlag2, setEmailMessageFlag2] = React.useState(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  function validateEmailCheck(email) {
    let valid = validateEmail(email);
    setEmailMessageFlag2(!valid);
  }

  function leaveSignupScreen(navigation, givenName, familyName, phone, email, reffererId) {
    // user_unset_firstrun();
    // navigation.replace("Donate");
  
    if (phone === "") {
      phone = "0";
    }
    if (email === "") {
      setEmailMessageFlag(true);
    } else {
      if (phone === "0" && email === "") {
        // show error?
        // console.log("error");
      } else {
        if (emailMessageFlag2) {
          // don't let people continue without valid emails
        } else {
          navigation.navigate("FirstSignInFinishSignup", {
            gName: givenName,
            fName: familyName,
            uPhone: phone,
            uEmail: email,
            reffererId: reffererId,
          });
        }
      }
    }
  }

  var isSetPhone =
    setPhone === 0 ||
    setPhone === "0" ||
    setPhone === "" ||
    setPhone === undefined
      ? false
      : true;
  var isSetEmail =
    setEmail === 0 ||
    setEmail === "0" ||
    setEmail === "" ||
    setEmail === undefined
      ? false
      : true;
  var isSetFname = setFname === undefined ? false : true;
  var isSetGname = setGname === undefined ? false : true;

  var isSetRef =
    setReferral === "" ||
    setReferral === undefined
      ? false
      : true;
  return (
    <View style={GlobalStyles.containerMB}>
      <View style={win.width > 768 ? [GlobalStyles.adjustableBodyContainer,{justifyContent: 'center', alignItems:"center"}] : styles.bodyContainerT }>
        <View style={styles.formContainer}>
          <Text style={styles.textStyleHeaderB}>My Account</Text>
          <Text style={styles.TextStyleBody}>
             Please take a moment to complete your profile.
          </Text>
          <View style={styles.formStyle}>
            <View style={styles.hiddenInputContainer}>
              {isSetGname === true ? (
                <View style={styles.inputBoxFaded}>
                  <Text style={styles.textFaded}>{setGname}</Text>
                </View>
              ) : (
                <View style={styles.inputBox}>
                  <TextInput
                    placeholder="First Name"
                    style={styles.textInput}
                    underlineColorAndroid="transparent"
                    value={givenName}
                    onChangeText={(text) => onChangeGivenNameText(text)}
                  />
                </View>
              )}
              {isSetFname === true ? (
                <View style={styles.inputBoxFaded}>
                  <Text style={styles.textFaded}>{setFname}</Text>
                </View>
              ) : (
                <View style={styles.inputBox}>
                  <TextInput
                    placeholder="Last Name"
                    style={styles.textInput}
                    underlineColorAndroid="transparent"
                    value={familyName}
                    onChangeText={(text) => onChangeFamilyNameText(text)}
                  />
                </View>
              )}
              {isSetEmail === true ? (
                <View style={styles.inputBoxFaded}>
                  <Text style={styles.textFaded}>{setEmail}</Text>
                </View>
              ) : (
                <View style={styles.inputBox}>
                  <TextInput
                    placeholder="Email"
                    style={styles.textInput}
                    underlineColorAndroid="transparent"
                    value={email}
                    onChangeText={(text) => {
                      onChangeEmailText(text);
                      validateEmailCheck(text);
                    }}
                  />
                  {emailMessageFlag ? <Text>Email is Required</Text> : <></>}
                  {emailMessageFlag2 ? <Text>Please Check Email is Valid!</Text> : <></>}
                </View>
              )}
              {isSetPhone === true ? (
                <View style={styles.inputBoxFaded}>
                  <Text style={styles.textFaded}>{setPhone}</Text>
                </View>
              ) : (
                <View style={styles.inputBox}>
                  <TextInput
                    placeholder="Phone"
                    style={styles.textInput}
                    underlineColorAndroid="transparent"
                    value={phone}
                    onChangeText={(text) => onChangePhoneText(text)}
                  />
                </View>
              )}
              {isSetRef === true ? (
                <View style={styles.inputBoxFaded}>
                  <Text style={styles.textFaded}>{setReferral}</Text>
                </View>
              ) : (
              <View style={styles.inputBox}>
                  <TextInput
                    placeholder="Referral Code (optional)"
                    style={styles.textInput}
                    underlineColorAndroid="transparent"
                    value={reffererId}
                    onChangeText={(text) => onChangeReffererIdText(text)}
                  />
                </View>
                )}
            </View>
          </View>
          <View style={styles.buttonContainer}>
            <TouchableOpacity
            style={styles.SubmitButtonStyleContinue}
            activeOpacity={0.5}
            onPress={() =>
              leaveSignupScreen(
                navigation,
                isSetGname === true ? setGname    : givenName,
                isSetFname === true ? setFname    : familyName,
                isSetPhone === true ? setPhone    : phone,
                isSetEmail === true ? setEmail    : email,
                isSetRef   === true ? setReferral : reffererId,
              )
            }
          >
            <Text style={styles.textStyleButton}>CONTINUE</Text>
          </TouchableOpacity>
        </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  bodyContainerT: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
    justifyContent: "center",
  },

  formStyle: {
    flexDirection: "column",
    width: "90%",
  },
  inputBox: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#FFFF",
    marginTop: 8,
    borderRadius: 20,
    justifyContent: "center",
  },

  inputBoxFaded: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#fee394",
    marginTop: 8,
    borderRadius: 20,
    justifyContent: "center",
  },
  formLabelStyle: {
    color: "#aaaaaa",
    textAlign: "center",
    textAlignVertical: "center",
    fontSize: 15,
    paddingRight: 20,
    paddingTop: 8,
    borderColor: "#CCCCCC",
    fontFamily: "montserrat-medium",
    fontSize: 11,
    textAlign: "left",
    paddingTop: 20,
    paddingBottom: 5,
  },
  bottomContainer: {},

  buttonContainer: {
    //flexDirection: "column",
    width: "95%",
    //alignContent: "flex-start",
    paddingLeft: 0,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 20,
  },

  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
  },
  TextStyleHeader: {
    color: "#ffffff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
    paddingLeft: 30,
    paddingRight: 30,
  },

  textStyleHeaderB: {
    color: "#ffffff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
    paddingLeft: 30,
    paddingRight: 30,
  },

  TextStyleBody: {
    color: "#000000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 14,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    paddingTop: 10,
  },

  textStyleButton: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
    //backgroundColor: "green"
  },

  formContainer: {
    alignContent: "center",
    backgroundColor: "#FFC72C",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 55,
    borderTopLeftRadius: 70,
    borderTopRightRadius: 70,
    borderBottomRightRadius: 70,
    paddingBottom: 55,
    maxWidth: 800,
  },

  SubmitButtonStyle: {
    marginTop: 10,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
  },

  SubmitButtonStyleContinue: {
    //paddingTop: 20,
    //paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    maxHeight: 60,
    minHeight: 60,
    justifyContent: "center",
    marginBottom: 20,
    marginTop:20,
  },



  SubmitButtonStyleBack: {
    //paddingTop: 20,
    //paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFC72C",
    borderColor: "#000000",
    flex: 1,
    borderWidth: 1,
    color: "#000000",
    height: 60,
    justifyContent: "center",
  },

  textInput: {
    borderColor: "#CCCCCC",
    // borderBottomWidth: 1,
    height: 35,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
    textAlign: "left",
    width: "100%",
  },
  textFaded: {
    //borderColor: "#CCCCCC",
    // borderBottomWidth: 1,
    height: 35,
    fontSize: 16,
    paddingRight: 20,
    paddingTop: 7,
    fontFamily: "montserrat-regular",
    textAlign: "left",
    width: "100%",
    color: "#666666",
  },


  optionIconContainer: {
    flex: 2,
    alignSelf: "center",
  },

  optionTextContainer: {
    flex: 6,
    alignSelf: "center",
  },

  optionSubtextContainer: {
    flex: 6,
    alignSelf: "center",
  },

  optionText: {
    color: "#506685",
    fontFamily: "montserrat-bold",
    fontSize: 15,
    textAlign: "left",
  },

  optionSubtext: {
    color: "#000000",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "right",
  },

  containerBox: {
    flex: 1,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
    marginBottom: 15,
  },

  containerA: {
    alignItems: "center",
    paddingTop: 20,
    paddingBottom: 20,
  },

  logoText: {
    paddingTop: 20,
  },

  smallLogo: {
    width: 107,
    height: 60,
    resizeMode: "contain",
  },
});
